import React, { useState, useEffect } from "react";
import ConferenceRegistration from "./components/ConferenceRegistration";
import Login from "./components/Login";
import CorporateGroupRegistration from "./components/CorporateGroupRegistration";
import GroupLogin from "./components/GroupLogin";

export default function App() {
  const [currentView, setCurrentView] = useState("mode-select"); // 'mode-select' | 'login' | 'group-login' | 'registration' | 'success'
  const [existingUser, setExistingUser] = useState(null);
  const [prefilledEmail, setPrefilledEmail] = useState("");
  const [registrationMode, setRegistrationMode] = useState("individual");
  const [groupLoginSession, setGroupLoginSession] = useState(null);

  const handleLoginSuccess = (userData) => {
    console.log("Login successful for user:", userData);
    setExistingUser(userData);
    setRegistrationMode("individual");
    setCurrentView("registration");
  };

  const handleGroupLoginSuccess = (sessionData) => {
    console.log("Group login successful:", sessionData);
    setGroupLoginSession(sessionData);
    setRegistrationMode("group");
    setCurrentView("registration");
  };

  const handleRegisterRedirect = (email = "") => {
    console.log("Redirecting to registration for email:", email);
    setPrefilledEmail(email);
    setExistingUser(null);
    setRegistrationMode("individual");
    setCurrentView("registration");
  };

  const handleBackToLogin = () => {
    setCurrentView("mode-select");
    setExistingUser(null);
    setPrefilledEmail("");
    setGroupLoginSession(null);
  };

  const renderModeSelection = () => (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #2f9bd1 0%, #0e78bc 100%)",
        padding: "16px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1024px",
          background: "#f5f6f8",
          borderRadius: "16px",
          padding: "28px",
          boxShadow: "0 16px 30px rgba(0,0,0,0.2)",
        }}
      >
        <h2
          style={{
            margin: 0,
            textAlign: "center",
            fontSize: "40px",
            color: "#333",
          }}
        >
          Choose Registration Type
        </h2>
        <p style={{ marginTop: "10px", textAlign: "center", color: "#666" }}>
          Select how you want to proceed
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "12px",
            marginTop: "16px",
          }}
        >
          <button
            type="button"
            onClick={() => {
              setRegistrationMode("individual");
              setCurrentView("login");
            }}
            style={{
              border: "none",
              borderRadius: "10px",
              padding: "14px 10px",
              background: "#0d6efd",
              color: "#fff",
              fontWeight: 700,
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Individual Registration
          </button>

          <button
            type="button"
            onClick={() => {
              setRegistrationMode("individual");
              setCurrentView("login");
            }}
            style={{
              border: "none",
              borderRadius: "10px",
              padding: "14px 10px",
              background: "rgb(25, 135, 84)",
              color: "#fff",
              fontWeight: 700,
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Submit Abstract & Register
          </button>

          <button
            type="button"
            onClick={() => {
              setRegistrationMode("group");
              setCurrentView("group-login");
            }}
            style={{
              border: "none",
              borderRadius: "10px",
              padding: "14px 10px",
              background: "#274c77",
              color: "#fff",
              fontWeight: 700,
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Group Registration (Corporate)
          </button>
        </div>
      </div>
    </div>
  );

  // Payment Success View
  if (currentView === "success") {
    // Show alerts and redirect to login
    useEffect(() => {
      alert("Payment successful! Processing registration...");
      setTimeout(() => {
        alert("Registered successfully. Details Emailed");
        // Clear URL and redirect to login
        window.history.replaceState({}, document.title, "/");
        setCurrentView("login");
        setExistingUser(null);
        setPrefilledEmail("");
      }, 500);
    }, []);

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          flexDirection: "column",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <div
          style={{
            padding: "40px",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            textAlign: "center",
            backgroundColor: "white",
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "20px" }}>✅</div>
          <h2 style={{ color: "#28a745", marginBottom: "10px" }}>
            Payment Successful!
          </h2>
          <p style={{ color: "#666", marginBottom: "20px" }}>
            Processing your registration...
          </p>
          <div
            style={{
              border: "3px solid #28a745",
              borderRadius: "50%",
              borderTop: "3px solid transparent",
              width: "40px",
              height: "40px",
              margin: "0 auto",
              animation: "spin 1s linear infinite",
            }}
          ></div>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  if (currentView === "mode-select") {
    return renderModeSelection();
  }

  if (currentView === "login") {
    return (
      <Login
        onLoginSuccess={handleLoginSuccess}
        onRegisterRedirect={handleRegisterRedirect}
        onBack={handleBackToLogin}
      />
    );
  }

  if (currentView === "group-login") {
    return (
      <GroupLogin
        onLoginSuccess={handleGroupLoginSuccess}
        onBack={handleBackToLogin}
      />
    );
  }

  return registrationMode === "group" ? (
    <CorporateGroupRegistration
      onBackToLogin={handleBackToLogin}
      groupLoginSession={groupLoginSession}
    />
  ) : (
    <ConferenceRegistration
      existingUser={existingUser}
      prefilledEmail={prefilledEmail}
      onBackToLogin={handleBackToLogin}
    />
  );
}
